var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 44,
    viewBox: "0 0 49 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6348 13.8302C37.5631 12.3702 36.2731 11.0602 34.8145 9.9502",
    stroke: "#2D97E9",
    strokeWidth: 2.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8456 18.0503C30.4587 17.6103 30.032 17.2104 29.5557 16.8604",
    stroke: "#2D97E9",
    strokeWidth: 2.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7062 15.8804C34.0017 14.9804 33.1979 14.1504 32.2949 13.4404",
    stroke: "#2D97E9",
    strokeWidth: 2.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0688 39.0708C45.2839 35.1408 47.2089 30.1108 47.2089 24.6208C47.2089 12.0408 37.0875 1.84082 24.6045 1.84082C12.1214 1.84082 2 12.0408 2 24.6208C2 30.1108 3.93497 35.1408 7.14008 39.0708",
    stroke: "#2D97E9",
    strokeWidth: 2.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2139 23.3501L42.1181 16.0801",
    stroke: "#2D97E9",
    strokeWidth: 2.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6143 6.33008V9.87006",
    stroke: "#2D97E9",
    strokeWidth: 2.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7734 11.6807L14.2641 14.1907",
    stroke: "#2D97E9",
    strokeWidth: 2.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46484 24.6201H9.97756",
    stroke: "#2D97E9",
    strokeWidth: 2.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7627 24.6201H39.25",
    stroke: "#2D97E9",
    strokeWidth: 2.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6141 27.53C26.2089 27.53 27.5017 26.2271 27.5017 24.62C27.5017 23.0128 26.2089 21.71 24.6141 21.71C23.0194 21.71 21.7266 23.0128 21.7266 24.62C21.7266 26.2271 23.0194 27.53 24.6141 27.53Z",
    stroke: "#2D97E9",
    strokeWidth: 2.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 37.5708C18.1845 35.2808 21.2309 33.8408 24.6146 33.8408C27.9983 33.8408 31.0447 35.2708 33.1979 37.5708",
    stroke: "#2D97E9",
    strokeWidth: 2.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4219 39.8904C19.9699 38.2304 22.1727 37.1904 24.6138 37.1904C27.0548 37.1904 29.2577 38.2304 30.8057 39.8904",
    stroke: "#2D97E9",
    strokeWidth: 2.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7637 42.16C21.7262 41.11 23.0956 40.46 24.6138 40.46C26.132 40.46 27.5113 41.11 28.4639 42.16",
    stroke: "#2D97E9",
    strokeWidth: 2.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstTitleIcon);
export default __webpack_public_path__ + "static/media/firstTitleIcon.484d190d5e231cd5e9757121cb93af75.svg";
export { ForwardRef as ReactComponent };